module.exports = __webpack_public_path__ + "images/5_switchpair.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/feeds/5_switchpair.jpg
// module id = 262
// module chunks = 0